<template>
  <div class="saticibilgi">

      <v-text-field hide-details :label="$t('Seller-Type')" v-model="saticiBilgi.SaticiTipi"></v-text-field>

      <v-text-field hide-details :label="$t('Seller-Code')" v-model="saticiBilgi.Kod"  required  v-on:change="$emit('kodonchange');" > </v-text-field>
      <v-text-field hide-details :label="$t('Name-of-Seller')" v-model="saticiBilgi.Isim"  required>  </v-text-field>
      <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="saticiBilgi.Cari_Kod.kod" v-model="saticiBilgi.Cari_Kod.kod" :Coper="true"></cariaracomp>
      <v-text-field hide-details :label="$t('Email_label')" v-model="saticiBilgi.Email"></v-text-field>
      <v-text-field hide-details :label="$t('Phonenumber_label')" v-model="saticiBilgi.Tel1"></v-text-field>
      <v-text-field hide-details :label="$t('Address_label')" v-model="saticiBilgi.Adres"></v-text-field>

  </div>
</template>

<script>

  //  import cariara from   '@/components/app/coper/comp/cariara.vue';
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'


export default {
  props: ['value'],
  data(){
    return{
      statecari:[]
    }
  },
  computed: {
    saticiBilgi() {
       return this.value;
    }
  },
  components: {
      // cariara,
    cariaracomp
},

  methods: {
    updateDate() {
      //const monthValue = this.$refs.monthPicker.value;
      //const yearValue = this.$refs.yearPicker.value;
      //this.$emit('input', `${monthValue}/${yearValue}`);
    },
    
  }
};
</script>